// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__AYB_g","right":"styles_right__1s-Vg"};